/**
 * An axios onUploadProgress handler that calls `onPercent` with 0–100 as the
 * request body goes up. Pass it in the request config:
 * `axios.post(url, formData, { onUploadProgress: uploadProgress(setPercent) })`.
 */
export const uploadProgress = (onPercent) => (event) => {
  const total = Number(event?.total);
  if (!total) return;
  onPercent(
    Math.min(100, Math.max(0, Math.round((event.loaded / total) * 100))),
  );
};

/**
 * What a save button says while files go up: "Preparing photos…" while photos
 * are still being shrunk, "Uploading 45%" while they go up, "Saving…" once
 * they're up and the server is still working. null when nothing is going up
 * (the button keeps its own label).
 */
export const uploadLabel = ({ preparing = false, percent = null } = {}) => {
  if (preparing) return "Preparing photos…";
  if (percent == null) return null;
  return percent < 100 ? `Uploading ${percent}%` : "Saving…";
};
